//! @ngInject
export function arReasonSetupModalCtrl($scope, $rootScope, $uibModalInstance, fields, data, DatabaseApi, toaster, FormService){

    $scope.fields = FormService.getFields(fields, data);

    $scope.form = {};

    $scope.fieldChanged = (item) => {
        if (item.type.type === "Boolean" && data.id) {
            $scope.submitForm();
        }
    }

    $scope.submitForm = () => {
        if ($scope.form.data.$invalid) return;

        const body = FormService.prepareFormData($scope.fields);
        
        if (data.id) {
            delete body.text;
            DatabaseApi.put(`agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/ar_reason_ref/${data.id}` , body)
                .then((res) => {
                    toaster.pop('success', "Reason saved");
                    $scope.closeModal();
                }, (err) =>{
                    toaster.pop('error', "Something went wrong", "Could not change reason settings")
                });
        } else {
            DatabaseApi.post(`agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/ar_reason_ref`, body).then((res) => {
                toaster.pop('success', "Reason saved");
                $scope.closeModal();
            }, (err) => {
                toaster.pop('error', "Something went wrong", "could not create reason");
            });
        }
    };

    $scope.closeModal = () => {
        $uibModalInstance.close('ok');
    };

    $scope.exit = () => {
        $uibModalInstance.dismiss();
    };

};
